import { getFetchOptions } from "../../utils";
var requestId = 0;
export default function useCartApi() {
    function request(url, data, method) {
        if (data === void 0) { data = undefined; }
        if (method === void 0) { method = "POST"; }
        var currentRequestId = ++requestId;
        return fetch(url, getFetchOptions(data, true, method))
            .then(function (response) {
            if (requestId !== currentRequestId) {
                return;
            }
            return response.json();
        });
    }
    var reloadGifts = function () { return request('/api/cart/gifts/get'); };
    var addGift = function (productId) { return request('/api/cart/gifts/add', { productId: productId }); };
    var removeGift = function (productId) { return request('/api/cart/gifts/remove', { productId: productId }); };
    function getGiftable() {
        return fetch('/api/cart/gifts/giftable', { credentials: 'same-origin' }).then(function (response) { return response.json(); });
    }
    var getAtomizers = function () { return request('/api/cart/atomizers'); };
    return {
        addGift: addGift,
        getGiftable: getGiftable,
        reloadGifts: reloadGifts,
        removeGift: removeGift,
        getAtomizers: getAtomizers
    };
}
